import { initialCallState } from '../../types';
import { releasePostCallUiLocks } from '../../../agent-widget/post-call-recovery.util';
import { shouldIgnoreStaleLiveCall } from '../../../agent-widget/acw-ui-lock';
import { CXoneEventsSubscriptionContext } from '../../subscription-context';
import { AgentStateEvent } from './agent-state-parsing.util';

export function applyCallStateFromAgentState(
  stateName: string,
  eventObj: AgentStateEvent,
  ctx: CXoneEventsSubscriptionContext
): void {
  const agentStateData = eventObj.agentStateData;
  const contactId = agentStateData?.contactId || agentStateData?.ContactId;

  if (
    shouldIgnoreStaleLiveCall(contactId ? String(contactId) : ctx.callStateRef.current.contactId) &&
    (stateName === 'OutboundContact' ||
      stateName === 'Active' ||
      stateName === 'InboundContactHandling' ||
      stateName === 'InboundContact' ||
      stateName === 'Inbound')
  ) {
    return;
  }

  if (stateName === 'InboundContact' || stateName === 'Inbound') {
    const currentCall = ctx.callStateRef.current;
    if (currentCall.contactId || currentCall.status !== 'idle') {
      return;
    }

    const contactId = agentStateData?.contactId || agentStateData?.ContactId;
    const ani = agentStateData?.ani || agentStateData?.ANI || agentStateData?.fromAddress;
    const dnis = agentStateData?.dnis || agentStateData?.DNIS || agentStateData?.toAddress;
    const skillId =
      agentStateData?.skillId ||
      agentStateData?.SkillId ||
      agentStateData?.skill ||
      agentStateData?.Skill;
    const skillName = agentStateData?.skillName || agentStateData?.SkillName;

    ctx.setIsRinging(true);
    ctx.setCallState((prev) => ({
      ...prev,
      contactId: contactId ? String(contactId) : prev.contactId,
      status: 'ringing',
      direction: 'INBOUND',
      callerNumber: ani ? String(ani) : prev.callerNumber,
      skillName: skillName ? String(skillName) : prev.skillName,
      skillId: skillId ? String(skillId) : prev.skillId,
      dnis: dnis ? String(dnis) : prev.dnis,
    }));
    return;
  }

  if (stateName === 'OutboundContact') {
    const contactId = agentStateData?.contactId || agentStateData?.ContactId;
    const dialedNumber =
      agentStateData?.toAddress ||
      agentStateData?.ToAddress ||
      agentStateData?.phoneNumber ||
      agentStateData?.PhoneNumber ||
      agentStateData?.ani ||
      agentStateData?.ANI;

    ctx.setIsRinging(false);
    ctx.setCallState((prev) => ({
      ...prev,
      contactId: contactId ? String(contactId) : prev.contactId,
      status:
        prev.status === 'active' || prev.status === 'holding'
          ? prev.status
          : prev.status === 'idle'
            ? 'connecting'
            : prev.status,
      direction: 'OUTBOUND',
      callerNumber: dialedNumber ? String(dialedNumber) : prev.callerNumber,
      startTime: prev.startTime || new Date(),
    }));
    return;
  }

  if (stateName === 'Active' || stateName === 'InboundContactHandling') {
    ctx.setIsRinging(false);
    ctx.setCallState((prev) => ({
      ...prev,
      status: 'active',
      startTime: prev.startTime || new Date(),
    }));
    ctx.setIsAgentLegActive(true);
    return;
  }

  if (stateName?.toLowerCase() === 'available' || stateName?.toLowerCase() === 'unavailable') {
    ctx.setCallState((prev) => {
      if (prev.status !== 'idle') {
        releasePostCallUiLocks();
        return initialCallState;
      }
      return prev;
    });
    ctx.setIsRinging(false);
    ctx.setIsAgentLegActive(false);
    ctx.setCallError(null);
  }
}
